import { GET_SLA_ASSIGNEE, GET_SLA_ASSIGNEE_SUCCESS, GET_SLA_ASSIGNEE_ERROR, GET_SLA_ASSIGNEE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSlaAssignee = (state = initialState, action) => {
  switch (action.type) {
    case GET_SLA_ASSIGNEE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SLA_ASSIGNEE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SLA_ASSIGNEE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SLA_ASSIGNEE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSlaAssignee;
